<div class="mini-profile-card" [class]="profile?.role">
  <div class="role-badge">{{ roleLabel }}</div>
  <div class="avatar">
    @if (profile?.avatarUrl) {
      <img [src]="profile.avatarUrl" [alt]="displayName" />
    } @else {
      <span class="initials">{{ displayName.charAt(0) }}</span>
    }
  </div>
  <div class="info">
    <span class="name">{{ displayName }}</span>
    @if (profile?.companyName && profile?.name && profile?.companyName !== profile?.name) {
      <span class="subtitle">{{ profile.name }}</span>
    }
  </div>
</div>
